import AIcon from "aloha-vue/src/AIcon/AIcon";

// @vue/component
export default {
  name: "PuxIconSlot",
  components: {
    AIcon,
  },
  props: {
    inDropdown: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: undefined,
    },
    labelFiltered: {
      type: String,
      required: false,
      default: undefined,
    },
  },
};
